import React from "react";
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineUsergroupAdd,
  AiOutlinePauseCircle,
  AiOutlineFall,
  AiOutlineRise,
} from "react-icons/ai";
import { useStores } from "../../store"; // Ensure this path is correct and the store is properly initialized

export const StatusCardMobile = ({
  color,
  icon,
  title,
  count,
  percentage,
  lastMonthText,
  filter,
}) => {
  const isPositive = parseFloat(percentage) > -0.000009;
  const trendIcon = isPositive ? (
    <AiOutlineRise className="w-3 h-3" />
  ) : (
    <AiOutlineFall className="w-3 h-3" />
  );
  const trendColor = isPositive ? "text-green-500" : "text-red-500";

  const { RecuiterStore } = useStores();

  return (
    <div
      className="flex block md:hidden items-center space-x-2 w-auto hover:cursor-pointer"
      onClick={() => {
        RecuiterStore.setStatus(filter);
        RecuiterStore.fetchapplicants();
        console.log("Status set to: ", RecuiterStore.status);
      }}
    >
      <div
        className={`rounded-full mb-2 h-6 w-6 flex items-center justify-center ${color}`}
      >
        {icon}
      </div>
      <div className="text-white">
        <div className="font-medium text-xs">
          {title} <span className="ml-2 ">{count ?? "-"}</span>
        </div>
        <div className={`${trendColor} text-xs flex items-center`}>
          {trendIcon}
          <span className="ml-1">
            {isPositive && "+"}
            {percentage}
          </span>
          <span className="ml-1 text-gray-500 whitespace-nowrap">
            {lastMonthText}
          </span>
        </div>
      </div>
    </div>
  );
};

const TotalApplicantsMobile = ({
  totalApplicants,
  shortListed,
  onHold,
  hired,
  rejected,
  shortlistPercentage,
  rejectPercentage,
  onHoldPercentage,
  hiredPercentage,
}) => {
  return (
    <div className="bg-black h-48 rounded-md p-4">
      <div className="text-white text-lg font-medium mb-6">
        Total Applicants
        <span className="text-orange-500 font-bold text-2xl ml-2">
          {totalApplicants ?? "-"}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <StatusCardMobile
          color="bg-blue-600"
          icon={<AiOutlineCheckCircle className="w-6 h-4 text-white" />}
          title="Shortlisted"
          count={shortListed}
          percentage={shortlistPercentage}
          lastMonthText="last month"
          filter={1}
        />
        <StatusCardMobile
          color="bg-yellow"
          icon={<AiOutlinePauseCircle className="w-6 h-4 text-white" />}
          title="On-Hold"
          count={onHold}
          percentage={onHoldPercentage}
          lastMonthText="last month"
          filter={0}
        />
        <StatusCardMobile
          color="bg-green-500"
          icon={<AiOutlineUsergroupAdd className="w-6 h-4 text-white" />}
          title="Hired"
          count={hired}
          percentage={hiredPercentage}
          lastMonthText="last month"
          filter={3}
        />
        <StatusCardMobile
          color="bg-red-600"
          icon={<AiOutlineCloseCircle className="w-6 h-4 text-white" />}
          title="Rejected"
          count={rejected}
          percentage={rejectPercentage}
          lastMonthText="last month"
          filter={2}
        />
      </div>
    </div>
  );
};

export default TotalApplicantsMobile;
